import React, { useRef } from "react";
import Slider from "react-slick";
import { Card, Image, Row, Col, Container } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import { m, LazyMotion, domAnimation } from "framer-motion";

import hildaImage from "../Image/DarkLogo.png";
import johnImage from "../Image/DarkLogo.png";
import janeImage from "../Image/DarkLogo.png";
import jayImage from "../Image/DarkLogo.png";

const Testimonial = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    customPaging: () => {
      return <div className="custom-dot mt-3" />;
    },
    appendDots: (dots) => (
      <div>
        <ul className="d-flex justify-content-center list-unstyled">{dots}</ul>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const testimonials = [
    {
      text: t("testimonial1"),
      name: t("testimonialName1"),
      location: t("testimonialLocation1"),
      testimonialImage: hildaImage,
    },
    {
      text: t("testimonial2"),
      name: t("testimonialName2"),
      location: t("testimonialLocation2"),
      testimonialImage: johnImage,
    },
    {
      text: t("testimonial3"),
      name: t("testimonialName3"),
      location: t("testimonialLocation3"),
      testimonialImage: janeImage,
    },
    {
      text: t("testimonial4"),
      name: t("testimonialName4"),
      location: t("testimonialLocation4"),
      testimonialImage: jayImage,
    },
    {
      text: t("testimonial5"),
      name: t("testimonialName5"),
      location: t("testimonialLocation5"),
      testimonialImage: jayImage,
    },
  ];

  return (
    <LazyMotion features={domAnimation}>
      <m.section
        ref={sectionRef}
        className="pb-5 bg-white text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { duration: 0.4, ease: "easeOut" } },
        }}
        style={{ willChange: "opacity" }}
        id="testimonials"
      >
        <Container className="justify-content-center">
          <Row className="m-0">
            <Col lg={12} className="justify-content-center d-flex p-0">
              <div className="headingTextMain">
                <h2
                  className="text-center mb-4 feature-title"
                  style={{ color: "var(--primary-color)" }}
                >
                  {t("testimonialHeader")}
                </h2>
              </div>
            </Col>
          </Row>
          <div className="col-lg-12">
            <Slider {...settings} className="testimonial-slider">
              {testimonials.map((testimonial, index) => (
                <m.div
                  key={index}
                  whileHover={{ scale: 1.02, transition: { duration: 0.2, ease: "easeOut" } }}
                  className="h-100"
                  style={{ willChange: "transform" }}
                >
                  <Card
                    className="TestimonialCard mt-0 d-flex h-100 border-0 rounded-4 position-relative"
                    style={{
                      boxShadow: "0 10px 10px rgba(0, 0, 0, 0.08)",
                      backgroundColor: "var(--white)",
                      padding: "2rem",
                      marginTop: "10px",
                    }}
                  >
                    <div className="position-absolute top-0 start-0 p-3 ms-2">
                      <i className="bi bi-quote fs-1" style={{ color: "var(--primary-color)", opacity: 0.2 }}></i>
                    </div>

                    <Card.Body className="d-flex flex-column align-items-center text-center p-0">

                      <Card.Text
                        className="test_card_text_1 text-center fs-6 mb-4 mt-2"
                        style={{
                          color: "var(--text-dark)",
                          fontStyle: "italic",
                          lineHeight: "1.6",
                          marginTop: "1rem"
                        }}
                      >
                        "{testimonial.text}"
                      </Card.Text>

                      <div className="mt-auto d-flex align-items-center flex-column">
                        <div className="profile-image-wrapper mb-3">
                          <Image
                            src={testimonial.testimonialImage}
                            roundedCircle
                            alt="Profile"
                            width="60"
                            height="60"
                            className="profile-image"
                            style={{
                              border: "3px solid var(--secondary-color)",
                              padding: "2px"
                            }}
                          />
                        </div>
                        <h6
                          className="mb-1 test_card_text_2 fw-bold"
                          style={{ color: "var(--primary-color)" }}
                        >
                          {testimonial.name}
                        </h6>
                        <small
                          className="test_card_text_3 text-uppercase"
                          style={{
                            color: "var(--text-muted)",
                            fontSize: "0.75rem",
                            letterSpacing: "0.5px"
                          }}
                        >
                          {testimonial.location}
                        </small>
                      </div>
                    </Card.Body>
                  </Card>
                </m.div>
              ))}
            </Slider>
          </div>
        </Container>
      </m.section>
    </LazyMotion>
  );
};

export default Testimonial;
